// Lib
import chroma from 'chroma-js';
import { Thunk } from '../../../../../types/reduxTypes';
import Immutable from 'immutable';

// Actions
import { getNewElementId } from '../../../../../element/actions/elementActions';
import { createLabel } from '../../../../../../common/labels/labelActions';

// Types
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { Label, LabelCreationData } from '../../../../../../common/labels/labelTypes';
import {
    addLabelToElements,
    removeLabelFromElements,
    replaceLabelOnElements,
} from '../../../../../element/labels/elementLabelActions';
import { getElements } from '../../../../../element/selectors/elementSelector';
import { getElement } from '../../../../../../common/elements/utils/elementTraversalUtils';
import { getNewTransactionId } from '../../../../../utils/undoRedo/undoRedoTransactionManager';

export const createNewLabelThunk =
    (labelData: LabelCreationData, transactionId?: number): Thunk<Label> =>
    (dispatch: Function) => {
        const id = dispatch(getNewElementId());

        const { name, creator, color } = labelData;
        const label = {
            id,
            name,
            color: color || chroma.random().hex(),
            meta: {
                creator,
                createdTime: Date.now(),
                modifiedTime: Date.now(),
            },
        };

        dispatch(createLabel(label, transactionId));
        return label;
    };

export const addLabelToElementsThunk =
    (
        label: Label,
        elements: Immutable.List<ImMNElement>,
        transactionId?: number,
    ): Thunk =>
    (dispatch: Function) => {
        dispatch(addLabelToElements(elements, label.id, transactionId));
    };

export const createAndAddLabelToElementsThunk =
    (labelData: LabelCreationData, elements: Immutable.List<ImMNElement>): Thunk =>
    (dispatch: Function) => {
        const sharedTransactionId = getNewTransactionId();
        const newLabel = dispatch(createNewLabelThunk(labelData, sharedTransactionId));
        dispatch(addLabelToElementsThunk(newLabel, elements, sharedTransactionId));
    };

export const replaceLabelIdForElementsThunk =
    (elementIds: string[], oldLabelId: string, newLabelId?: string): Thunk =>
    (dispatch: Function, getState: Function) => {
        const state = getState();
        const elements = getElements(state);

        const updatingElements = Immutable.List(elementIds.map((id) => getElement(elements, id)));
        if (!updatingElements || updatingElements.size === 0) return;

        if (!newLabelId) {
            // If no new label id is provided, we are just removing the old label from the elements
            return dispatch(removeLabelFromElements(updatingElements, oldLabelId));
        }

        dispatch(replaceLabelOnElements(updatingElements, oldLabelId, newLabelId));
    };
